import { validateRecordingPackageV1 } from "./validators.js";
import { RECORDING_SCHEMA_VERSION, } from "./types.js";
/**
 * Migration registry. Add new entries as schema bumps land.
 *
 * Each entry takes the input shape of `from` and returns the input shape of `to`.
 * `migrateRecordingPackage` will walk the registry from the input version up to
 * the latest version, applying each migration in sequence.
 */
export const migrationRegistry = [
// No migrations yet — 0.1.0 is the inaugural schema version.
];
function getSchemaVersion(input) {
    if (typeof input === "object" && input !== null && "schemaVersion" in input) {
        const version = input.schemaVersion;
        return typeof version === "string" ? version : null;
    }
    return null;
}
export function migrateRecordingPackage(input) {
    const sourceVersion = getSchemaVersion(input);
    if (!sourceVersion) {
        return {
            ok: false,
            error: { code: "invalid-manifest", message: "schemaVersion missing or not a string" },
        };
    }
    let current = input;
    let currentVersion = sourceVersion;
    const applied = [];
    while (currentVersion !== RECORDING_SCHEMA_VERSION) {
        const entry = migrationRegistry.find((m) => m.from === currentVersion);
        if (!entry) {
            return {
                ok: false,
                error: { code: "unsupported-schema", schemaVersion: currentVersion },
            };
        }
        current = entry.migrate(current);
        currentVersion = entry.to;
        applied.push(`${entry.from}->${entry.to}`);
    }
    const validation = validateRecordingPackageV1(current);
    if (!validation.ok) {
        return {
            ok: false,
            error: {
                code: "invalid-manifest",
                message: validation.errors.map((e) => `${e.path}: ${e.message}`).join("; "),
            },
        };
    }
    return { ok: true, package: current, appliedMigrations: applied };
}
